import React from 'react';
import styled from 'styled-components';
import AppStore from '../../assets/AppStore';
import { NewTabLink, Button } from '../../components/common';
import AndroidStore from '../../assets/AndroidStore';

export default ({ links }) => (
  <ButtonsWrapper>
    {links.websiteUrl && (
      <NewTabLink href={links.websiteUrl}>
        <GoToWebsiteButton blue>Prohlédnout</GoToWebsiteButton>
      </NewTabLink>
    )}
    {links.appStoreUrl && (
      <Store href={links.appStoreUrl}>
        <AppStore />
      </Store>
    )}
    {links.androidStoreUrl && (
      <Store href={links.androidStoreUrl}>
        <AndroidStore />
      </Store>
    )}
  </ButtonsWrapper>
);

const GoToWebsiteButton = styled(Button)`
  margin: 8px 0;
  padding: 10px 18px;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  & > *:not(:last-child) {
    margin-right: 16px;
  }
`;

const Store = styled(NewTabLink)`
  opacity: 0.8;
  &:hover {
    opacity: 1;
  }
  cursor: pointer;
  width: 42px;
  height: 42px;
`;
